import { createMuiTheme } from "@material-ui/core";

import palette from "./palette";
import typography from "./typography";
import spacing from "./spacing";
import overrides from "./overrides";

const theme = createMuiTheme({
  palette,
  typography,
  spacing,
  overrides
});

export default theme;
